import { formatLength, formatArea } from './unitConversion';

export const formatImperialLength = (totalFeet: number, unitSystem: 'imperial' | 'metric' = 'imperial'): string => {
  if (unitSystem === 'metric') {
    return formatLength(totalFeet * 12, unitSystem); // Convert feet to inches first
  }
  const feet = Math.floor(totalFeet);
  const remainingInches = ((totalFeet - feet) * 12);
  
  // Round inches to nearest whole number
  const inchesRounded = Math.round(remainingInches);
  
  // Handle case where rounding inches gives us 12 inches
  if (inchesRounded === 12) {
    return `${feet + 1}'`;
  }
  
  if (feet === 0) {
    return `${inchesRounded}"`;
  } else if (inchesRounded === 0) {
    return `${feet}'`;
  } else {
    return `${feet}'-${inchesRounded}"`;
  }
};

export const formatImperialArea = (squareFeet: number, unitSystem: 'imperial' | 'metric' = 'imperial'): string => {
  if (unitSystem === 'metric') {
    return formatArea(squareFeet, unitSystem);
  }
  return `${squareFeet.toFixed(2)} sq ft`;
};

export const coordToInches = (coordValue: number): number => {
  return coordValue;
};